<template>
    <v-dialog max-width="500px" v-model="dialog">
        <v-card min-width="400px">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions>
                <v-text-field class="ml-5 mr-5" label="Order" hide-details type="number" v-model="groupOrder" outlined dense></v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-text-field v-model="groupName"
                              class="ml-5 mr-5"
                              label="Group Name"
                              outlined></v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-color-picker
                        v-model="groupColor"
                        class="ml-8"
                        dot-size="25"
                        swatches-max-height="200"
                        width="400px"
                        show-swatches
                        hide-inputs
                ></v-color-picker>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        class="ma-2"
                        color="primary"
                        @click="onPressUpdate">UPDATE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {LocalizationStoreUtils} from "@/modules/mlocalization/database/LocalizationStoreUtils";

export default {
    name: "l-edit-group-popup",
    props: {},
    data: () => ({
        buttonLoading: false,
        dialog: false,
        groupName: "",
        groupColor: "",
        groupOrder: 0,
        group: null
    }),
    computed: {},
    methods: {
        show(group) {
            this.group = group
            this.dialog = true
            this.groupName = group.name
            this.groupColor = group.color
            this.groupOrder = group.order || 0
            this.buttonLoading = false
        },
        hide() {
            this.dialog = true
        },
        onClose() {
            this.dialog = false
        },
        onPressUpdate() {
            if (this.groupName == ''){
                this.$notify({title: 'Group Name Its Empty!', type: "error"});
                return
            }
            this.buttonLoading = true
            LocalizationStoreUtils.updateGroup(this.group.group_id, this.groupName, this.groupColor, this.groupOrder)
            .then(() => {
                this.buttonLoading = false
                this.dialog = false
                this.$notify({title: 'Group updated!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.buttonLoading = false
                this.dialog = false
                this.$notify({title: 'Group update failed!', text: error, type: "error"});
            })
        }
    }

}
</script>

<style scoped>

</style>